// Players' accounts as the site and the server both see them: who is signed in, and the rules for what they type.

/** The signed-in player (never the password or the email's owner's other details). */
export interface PlayerInfo {
  /** the name others see: the GG Bharat name registered with this email if there is one */
  displayName: string;
  instagram: string | null;
  email: string;
  /** may play now, while the game is waitlist-only (invited to the beta) */
  beta: boolean;
  /** their place on the waitlist: the GG Bharat name registered (₹49) with this email, if any */
  claim: { name: string; founder: number | null; paid: boolean } | null;
}

export const PASSWORD_MIN = 8;
const EMAIL = /^[^\s@]{1,64}@[^\s@]{1,190}\.[^\s@]{2,24}$/;

export function validateEmail(raw: unknown): { ok: true; value: string } | { ok: false; error: string } {
  const v = typeof raw === 'string' ? raw.trim().toLowerCase() : '';
  return EMAIL.test(v) ? { ok: true, value: v } : { ok: false, error: 'Enter a valid email address.' };
}

export function validatePassword(raw: unknown): { ok: true; value: string } | { ok: false; error: string } {
  if (typeof raw !== 'string' || raw.length < PASSWORD_MIN) return { ok: false, error: `Use at least ${PASSWORD_MIN} characters for the password.` };
  if (raw.length > 200) return { ok: false, error: 'That password is too long.' };
  return { ok: true, value: raw };
}
